/**
 * Build dropdown options from Google Sheet **Lookups** tab (`lookup_columns` on snapshot).
 * When the sheet has values for a column, those win; otherwise `fallback` constants apply.
 * `currentValue` is always included so editing a row with a legacy/orphan value still works.
 */
export function optionsFromLookup(
	key: string,
	lookup: Record<string, string[]> | undefined,
	fallback: readonly string[],
	currentValue?: string,
): string[] {
	const fromSheet = (lookup?.[key] ?? [])
		.map(s => String(s).trim())
		.filter(Boolean)
	const base = fromSheet.length > 0 ? fromSheet : [...fallback]
	const set = new Set(base)
	const cur = (currentValue ?? '').trim()
	if (cur) set.add(cur)
	return [...set].sort((a, b) => a.localeCompare(b))
}
